import { sha256Js } from "./sha256-js";

function bytesToHex(bytes: Uint8Array): string {
  return Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join(
    "",
  );
}

/**
 * SHA-256 hex digest that works in every runtime clients actually run in.
 * `crypto.subtle` only exists in secure contexts — a dev server or tunnel
 * reached over plain-HTTP LAN IP does not qualify — so insecure contexts
 * fall back to the pure-JS implementation.
 */
export async function sha256HexOfBytes(
  bytes: Uint8Array<ArrayBuffer>,
): Promise<string> {
  const subtle = globalThis.crypto?.subtle;
  if (subtle) {
    try {
      const digest = await subtle.digest("SHA-256", bytes);
      return bytesToHex(new Uint8Array(digest));
    } catch {
      // Fall through to the JS implementation.
    }
  }
  return bytesToHex(sha256Js(bytes));
}
